import createBaseLayer from './base-layer';

export default (props, model) => {
  const self = createBaseLayer(model);

  model.layerType = 'report';

  // hack alert. Todo: standardize approach of identifying layer type
  model.isReportLayer = true;

  return self;
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/layer/types/report-layer.js